import * as Yup from "yup";

export default Yup.object().shape({
    id: Yup.number(),
    key: Yup.string().required("Name is required"),
    value: Yup.string().required("Name is required")
});